import firebase from './firebase';
import firebaseMessages from './messages';

export {
  firebase,
  firebaseMessages,
};



// WEBPACK FOOTER //
// ./src/common/lib/redux-firebase/index.js